import { motion } from "framer-motion";
import { Check, Compass } from "lucide-react";
import { cn } from "@/lib/utils";

export function StageStepper({ stages, current, suggested, onSelect, pending }) {
  const idx = stages.findIndex((s) => s.key === current);
  return (
    <div data-testid="stage-stepper" className="relative">
      <div className="grid grid-cols-4 gap-2 sm:gap-4">
        {stages.map((s, i) => {
          const isCurrent = s.key === current;
          const isPast = i < idx;
          const isSuggested = s.key === suggested && !isCurrent;
          return (
            <button key={s.key} type="button" disabled={pending} onClick={() => !isCurrent && onSelect(s.key)}
              data-testid={`stage-${s.key}`} aria-current={isCurrent ? "step" : undefined}
              className={cn("group text-left relative rounded-2xl border p-3 sm:p-4 transition-all duration-200",
                isCurrent ? "bg-emerald-600 border-emerald-600 text-white shadow-lg shadow-emerald-600/20"
                  : isSuggested ? "bg-white border-emerald-400 border-dashed hover:border-emerald-500"
                    : "bg-white border-slate-200/80 hover:border-emerald-300 hover:shadow-sm")}>
              <div className="flex items-center gap-2.5">
                <span className={cn("w-7 h-7 rounded-full flex items-center justify-center text-xs font-mono font-semibold flex-shrink-0 transition-colors",
                  isCurrent ? "bg-white text-emerald-700" : isPast ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500 group-hover:bg-emerald-50 group-hover:text-emerald-600")}>
                  {isPast ? <Check className="w-3.5 h-3.5" /> : i + 1}
                </span>
                <div className="min-w-0">
                  <div className={cn("font-display font-semibold text-sm sm:text-base leading-tight truncate", isCurrent ? "text-white" : "text-slate-900")}>{s.name}</div>
                  <div className={cn("text-[11px] leading-tight hidden sm:block truncate", isCurrent ? "text-emerald-100" : "text-slate-500")}>{s.who}</div>
                </div>
              </div>
              <div className={cn("text-xs mt-2.5 leading-snug hidden md:block line-clamp-2", isCurrent ? "text-emerald-50" : "text-slate-500")}>{s.focus}</div>
              {isCurrent && <span className="absolute top-2 right-2 text-[10px] font-mono uppercase tracking-wider bg-white/15 px-1.5 py-0.5 rounded-md" data-testid="stage-current-marker">Current</span>}
              {isSuggested && (
                <motion.span initial={{ opacity: 0, y: -4 }} animate={{ opacity: 1, y: 0 }} data-testid="stage-suggested-marker"
                  className="absolute -top-2.5 right-3 inline-flex items-center gap-1 text-[10px] font-medium bg-white text-emerald-700 border border-emerald-300 px-2 py-0.5 rounded-full shadow-sm">
                  <Compass className="w-3 h-3" /> Suggested
                </motion.span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
